// while drawing (pipe, point, pit) or in the studio, clicks on areas / drawings go through to the map
export const passClick = (e) => {
  if (!window.__gissDrafting && !window.__gissStudio) return false;
  e.target._map?.fire('click', { latlng: e.latlng, originalEvent: e.originalEvent });
  return true;
};
